import React from 'react';

/**
 * Custom molar tooth SVG — outline style to match Lucide's stroke-based icons.
 * strokeWidth="2", strokeLinecap="round", strokeLinejoin="round" mirrors
 * the exact visual weight of the installed Lucide icon set.
 */
const ToothIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/*
      Molar outline:
      - Wide crown at top with two gentle cusps
      - Body tapering toward root junction
      - Two diverging roots at the bottom
    */}
    <path d="
      M 8 21
      C 7 21 6.5 20 6.5 18.5
      L 6.5 15
      C 6.5 14 6 13.2 5.5 12.5
      L 5 9.5
      C 4.5 7.5 4.8 5.5 6 4
      C 7 2.8 8.8 2 12 2
      C 15.2 2 17 2.8 18 4
      C 19.2 5.5 19.5 7.5 19 9.5
      L 18.5 12.5
      C 18 13.2 17.5 14 17.5 15
      L 17.5 18.5
      C 17.5 20 17 21 16 21
      C 15 21 14.5 20 14.5 18.5
      C 14.5 17 14 16 12 16
      C 10 16 9.5 17 9.5 18.5
      C 9.5 20 9 21 8 21 Z
    " />
    {/* Centre groove between the two cusps */}
    <path d="M 12 7 L 12 10" />
  </svg>
);

export default ToothIcon;
